import React, { FC } from 'react';
import { Button, ButtonSkin } from '@wix/design-system';
import { useEditUrl } from '../../hooks/useNewEditUrl';
import { useTranslation } from '@wix/wix-i18n-config';
import { useBiLogger } from '../../contexts/BILoggerContext';
import { Template } from '../../domain/entities/template';

interface EditButtonProps {
  template: Template;
  skin: ButtonSkin;
  index?: number;
  dataHook?: string;
  className?: string;
  tabName?: string;
  categorySlug?: string;
}

export const EditButton: FC<EditButtonProps> = ({
  template,
  index,
  dataHook,
  skin,
  className,
  tabName,
  categorySlug,
}) => {
  const { t } = useTranslation();
  const editUrl = useEditUrl(template);
  const biLogger = useBiLogger();
  const onEditClick = () => {
    biLogger.reportEditTemplate({ ...template, index, tabName, categorySlug });
  };

  return (
    <Button
      as="a"
      size="large"
      skin={skin}
      className={className}
      target="_blank"
      onClick={onEditClick}
      href={editUrl}
      dataHook={dataHook}
    >
      {t('app.templates.grid.edit.button')}
    </Button>
  );
};
